import { Checkbox as AntdCheckboxProps } from 'antd';
import { CheckboxProps as AntCheckboxProps } from 'antd/lib/checkbox';
import React from 'react';
import 'antd/es/checkbox/style/index.less';
import './index.less';

interface CheckboxProps extends AntCheckboxProps {}

const Checkbox: React.FC<CheckboxProps> = (props) => {
    return <AntdCheckboxProps {...props} />;
};

export default Checkbox;
